import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import Toasted from 'vue-toasted';
import VueSocketio from 'vue-socket.io-extended';
import io from 'socket.io-client';
import contenteditableDirective from 'vue-contenteditable-directive';
import VueTypedJs from 'vue-typed-js';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

// Initialize Google Places Autocomplete
let g = document.createElement('script');
g.type = 'text/javascript';
g.onload = function () {
  store.commit('GOOGLE_API_LOADED');
};
g.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_PLACES_API_KEY}&libraries=places&region=US`;
g.async = true;
document.body.appendChild(g);

const veeValidateConfig = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  strict: true,
  validity: false
};

const vueToastOptions = {
  duration: 2000,
  className: 'toast-background-color',
  position: 'top-center'
};

Vue.use(VeeValidate, veeValidateConfig);
Vue.use(Toasted, vueToastOptions);
Vue.use(VueSocketio, io(process.env.VUE_APP_SOCKET_URL, { secure: true, autoConnect: false }));
Vue.use(contenteditableDirective);
Vue.use(VueTypedJs);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
